import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  mobile: boolean;
  isSura: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      position: 'fixed',
      boxShadow: '0 2px 16px rgba(0, 0, 0, 0.08)',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      zIndex: 2,
      padding: '0 4rem',
      boxSizing: 'border-box',
      '&.flat': {
        boxShadow: 'none',
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: theme.oysterTheme.stone,
      },
      '&.isSura': {
        boxShadow: '0 2px 16px rgba(0, 0, 0, 0.08)',
      },
    },
    content: {
      display: 'flex',
      justifyContent: ({ mobile }: StyleProps) => (mobile ? 'center' : 'space-between'),
      alignItems: 'center',
      height: '72px',
    },
    logo: {
      width: 'auto',
      maxHeight: ({ mobile, isSura }: StyleProps) => (mobile && isSura ? '30px' : '40px'),
    },
    button: {
      boxShadow: 'none',
      borderRadius: 8,
      fontWeight: 600,
      fontSize: 16,
      padding: '10px 45px',
      textTransform: 'none',
      backgroundColor: theme.oysterTheme.oyster,
      color: `${theme.palette.primary.contrastText} !important`,
      '&:hover': {
        backgroundColor: theme.oysterTheme.oyster,
        textDecoration: 'none',
      },
    },
  }),
);

export default useStyles;
